import { useState, useCallback } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export function useJiraSync() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Save Jira credentials
  const saveCredentials = useCallback(async ({ jiraHost, jiraUsername, jiraPassword }) => {
    setLoading(true);
    setError(null);
    try {
      const saveJiraCredentialsFn = httpsCallable(functions, 'saveJiraCredentials');
      const result = await saveJiraCredentialsFn({ jiraHost, jiraUsername, jiraPassword });
      return result.data;
    } catch (err) {
      const message = err.message || 'Failed to save credentials';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Test Jira connection
  const testConnection = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const testJiraConnectionFn = httpsCallable(functions, 'testJiraConnection');
      const result = await testJiraConnectionFn();
      return result.data;
    } catch (err) {
      const message = err.message || 'Failed to test connection';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Get Jira configuration (without password)
  const getConfig = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const getJiraConfigFn = httpsCallable(functions, 'getJiraConfig');
      const result = await getJiraConfigFn();
      return result.data;
    } catch (err) {
      const message = err.message || 'Failed to get configuration';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  // Sync time entries to Jira
  const syncToJira = useCallback(async ({ entryIds, dryRun } = {}) => {
    setLoading(true);
    setError(null);
    try {
      const syncToJiraFn = httpsCallable(functions, 'syncToJira');
      const result = await syncToJiraFn({ entryIds, dryRun });
      return result.data;
    } catch (err) {
      const message = err.message || 'Failed to sync to Jira';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    saveCredentials,
    testConnection,
    getConfig,
    syncToJira,
  };
}
